module.exports = __webpack_public_path__ + "static/media/folder-arrow-down.f1ed5707.svg";